import { ComponentType } from "@angular/cdk/overlay";
import {
    createEnvironmentInjector,
    EnvironmentInjector,
    EnvironmentProviders,
    inject,
    Injectable,
    Injector,
} from "@angular/core";
import { ModalConfig } from "@Front-end/ui/models/modal";
import { ModalService } from "@Front-end/ui/modules/modal";
import { ModalRef } from "@Front-end/ui/modules/modal/utils";

export interface ModalConfigWithProviders<D = unknown> extends Partial<ModalConfig<D>> {
    environmentProviders?: EnvironmentProviders[];
}

@Injectable({
    // eslint-disable-next-line no-restricted-syntax
    providedIn: "root",
})
export class ModalWithInjectorService {
    private readonly modal = inject(ModalService);
    private readonly envInjector = inject(EnvironmentInjector);
    private readonly rootInjector = inject(Injector);

    public open<D>(
        component: ComponentType<unknown>,
        config: ModalConfigWithProviders<D> = {},
    ): ModalRef<D> | null {
        const { environmentProviders, ...modalConfig } = config;

        if (environmentProviders?.length) {
            const childEnvInjector = createEnvironmentInjector(
                environmentProviders,
                this.envInjector,
            );
            // Підміняємо parent injector на дочірній з лінивими провайдерами
            // eslint-disable-next-line
            (this.modal as any).injector = childEnvInjector;
            const ref = this.modal.open<D>(component, modalConfig);
            // eslint-disable-next-line
            (this.modal as any).injector = this.rootInjector;
            return ref;
        }

        return this.modal.open<D>(component, modalConfig);
    }
}
